import React from 'react';
import styles from './ListToolbar.module.css';

interface ListToolbarProps {
  children?: React.ReactNode;
  start?: React.ReactNode;
}

const ListToolbar = ({
  children,
  start,
}: ListToolbarProps) => (
  <div className={styles.toolbar}>
    <div className={styles.group}>
      {start}
    </div>
    <div className={`${styles.group} ${styles.end}`}>
      {children}
    </div>
  </div>
);

export const viewModeGroupClassName = styles.viewModes;

export default ListToolbar;
